function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import overSome from 'lodash/overSome';
import conformsTo from 'lodash/conformsTo';
import isString from 'lodash/isString';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import { Wrapper, Crumb, CrumbLink, CrumbSeparator, CrumbWrapper } from './styles';
var breadcrumbLinkShape = {
  to: overSome([isString, isObject]),
  label: isString
};
var breadcrumbComponentShape = {
  component: overSome([isFunction, isObject]),
  key: isString
};
export var crumbPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  to: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  label: PropTypes.string.isRequired
}), PropTypes.shape({
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  key: PropTypes.string
})]);
export var Breadcrumb = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Breadcrumb, _React$PureComponent);

  var _super = _createSuper(Breadcrumb);

  function Breadcrumb() {
    var _this;

    _classCallCheck(this, Breadcrumb);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderCrumb", function (crumb, i) {
      if (isString(crumb)) return /*#__PURE__*/React.createElement(Crumb, {
        key: crumb
      }, crumb);else if (Breadcrumb.isLink(crumb)) {
        var to = crumb.to,
            label = crumb.label;
        return /*#__PURE__*/React.createElement(CrumbLink, {
          to: to,
          key: Breadcrumb.getLinkKey(crumb)
        }, label);
      } else if (Breadcrumb.isComponent(crumb)) {
        var Component = crumb.component,
            key = crumb.key;
        return /*#__PURE__*/React.createElement(Component, {
          key: key
        });
      }
      throw new Error('Component: `Breadcrumb` received a crumb of an unrecognized type ' + typeof crumb + '.');
    });

    return _this;
  }

  _createClass(Breadcrumb, [{
    key: "renderCrumbSeparator",
    value: function renderCrumbSeparator(length, i) {
      return i === length - 1 ? null : /*#__PURE__*/React.createElement(CrumbSeparator, {
        key: "crumb-separator-".concat(i)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          crumbs = _this$props.crumbs,
          rest = _objectWithoutProperties(_this$props, ["crumbs"]);

      return /*#__PURE__*/React.createElement(Wrapper, rest, crumbs.map(function (crumb, i) {
        return /*#__PURE__*/React.createElement(CrumbWrapper, {
          key: "crumb-wrapper-".concat(i)
        }, _this2.renderCrumb(crumb), _this2.renderCrumbSeparator(crumbs.length, i));
      }));
    }
  }], [{
    key: "isLink",
    value: function isLink(crumb) {
      return conformsTo(crumb, breadcrumbLinkShape);
    }
  }, {
    key: "getLinkKey",
    value: function getLinkKey(_ref) {
      var to = _ref.to;
      if (isString(to)) return to;
      var _to$pathname = to.pathname,
          pathname = _to$pathname === void 0 ? '' : _to$pathname,
          _to$search = to.search,
          search = _to$search === void 0 ? '' : _to$search;
      return pathname + search;
    }
  }, {
    key: "isComponent",
    value: function isComponent(crumb) {
      return conformsTo(crumb, breadcrumbComponentShape);
    }
  }]);

  return Breadcrumb;
}(React.PureComponent);

_defineProperty(Breadcrumb, "propTypes", {
  crumbs: PropTypes.arrayOf(crumbPropType)
});

_defineProperty(Breadcrumb, "defaultProps", {
  crumbs: []
});

export default Breadcrumb;